import { createAsyncActionTypes } from 'src/core/util/async-action-type-creator';

export const LOGIN = createAsyncActionTypes('LOGIN');
export const REQUEST_PASSWORD_RESET = createAsyncActionTypes(
  'REQUEST_PASSWORD_RESET',
);
export const LOGOUT = 'LOGOUT';
export const RESET_LOGIN_FORM = 'RESET_LOGIN_FORM';
export const SET_USER = 'SET_USER';
